export default "__VITE_ASSET__BtCmTAuy__"